import React from 'react';
import { motion } from 'framer-motion';
import { YoutubeIcon, PlayIcon } from 'lucide-react';
const VideoSection = () => {
  return <section className="relative py-16 md:py-20 overflow-hidden" data-id="element-334">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-blue-50" data-id="element-335">
        <svg className="absolute inset-0 w-full h-full opacity-10" xmlns="http://www.w3.org/2000/svg" data-id="element-336">
          <defs data-id="element-337">
            <pattern id="wave-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse" data-id="element-338">
              <path d="M0 50 Q 25 30, 50 50 T 100 50" stroke="#1e40af" strokeWidth="0.5" fill="none" data-id="element-339" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#wave-pattern)" data-id="element-340" />
        </svg>
      </div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-341">
        <motion.div className="text-center mb-10 md:mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-342">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-blue-900 mb-3" data-id="element-343">
            Countdown to 70 Years
          </h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto mb-4" data-id="element-344"></div>
          <p className="text-gray-700 max-w-2xl mx-auto text-sm md:text-base px-4" data-id="element-345">
            Join us as we count down to our Platinum Jubilee. Seven decades of
            shaping minds, building futures, and soaring to greater heights.
          </p>
        </motion.div>
        <motion.div className="max-w-4xl mx-auto" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-346">
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-2xl p-4 md:p-6 border border-blue-100" data-id="element-347">
            <div className="relative aspect-video rounded-xl overflow-hidden bg-blue-950 shadow-inner" data-id="element-348">
              <video className="w-full h-full object-contain" controls autoPlay muted loop playsInline poster="https://cdn.magicpatterns.com/uploads/uQsM27rbNPREQmqUu3VS3W/IGS_70.jpg" data-id="element-349">
                <source src="https://cdn.magicpatterns.com/uploads/kSLnaCRrBAhuVk89iDgBsf/countdown.mp4" type="video/mp4" data-id="element-350" />
                Your browser does not support the video tag.
              </video>
            </div>
            <div className="mt-6 text-center" data-id="element-351">
              <h3 className="text-xl md:text-2xl font-bold text-blue-900 mb-2" data-id="element-352">
                IGS @ 70: Still Soaring at Seventy
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-353">March 23rd – 29th, 2026</p>
              <a href="/anniversary" className="inline-flex items-center justify-center bg-blue-900 hover:bg-blue-800 text-white font-bold py-3 px-8 rounded-full transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all" data-id="element-354">
                View Anniversary Programme
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};
export default VideoSection;